import { render } from "./ServiceWorkerForceUpdate.vue?vue&type=template&id=a8775fae"
import script from "./ServiceWorkerForceUpdate.vue?vue&type=script&lang=js"
export * from "./ServiceWorkerForceUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__